import React from "react";
import "./receipt.css";
import DynamicZoneLogo from "components/Common/DynamicZoneLogo";

const Receipt = () => {
  const [receiptData] = React.useState(() => {
    return JSON.parse(localStorage.getItem("receiptData"));
  });

  console.log(
    "****************receiptDatareceiptData****************",
    receiptData,
  );

  const allItems = [
    ...(receiptData?.investigtion_details || []),
    ...(receiptData?.package_details?.map((pkg) => ({
      investigation_name: pkg.package_name,
      investigation_id: pkg.package_id,
      mrp: pkg.mrp,
      rate: pkg.rate,
    })) || []),
  ];

  if (!receiptData) {
    return <div>No receipt data available</div>;
  }

  const printReceipt = () => {
    window.print();
  };

  return (
    <div className="recepit-container">
      <div className="receipt-wrapper">
        <div className="receipt-inner">
          <div className="d-flex align-items-center mb-2">
            <div className="logo col-4">
              <DynamicZoneLogo
                alt="LIS"
                width={140}
                height={90}
              />
            </div>
            <div className="receipt-header-unique col-8 d-flex justify-content-between align-items-center">
              Estimate Receipt
            </div>
          </div>
          <div className="ms-3 mt-3">
            <div className="row">
              <div className="receipt-row receipt16 receipt-status">
                Panel: <span>{receiptData?.company_name?.value || "N/A"}</span>
              </div>
            </div>
            <div className="row">
              <div className="receipt-row receipt16 receipt-status">
                Address: <span>{receiptData?.address || ""}</span>
              </div>
            </div>
          </div>
          <div className="receipt-row receipt-bttm-border">
            <div className="receipt-row-1 receipt-colheaders receipt24 ">
              Particulars
            </div>
            <div
              className="receipt-row-2 receipt-colheaders receipt24"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "50%",
              }}
            >
              <div style={{ width: "25%", textAlign: "left" }}>Item Code</div>
              <div style={{ width: "25%", textAlign: "right" }}>Amount</div>
            </div>
          </div>

          {allItems?.map((item, index) => (
            <div className="receipt-row receipt-bttm-border" key={index}>
              <div className="receipt-row-1">
                {item?.investigation_name || "N/A"}
              </div>
              <div
                className="receipt-row-2"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "50%",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    textAlign: "left",
                    wordBreak: "break-all",
                  }}
                >
                  {item?.investigation_id || ""}
                </div>
                <div
                  style={{
                    width: "25%",
                    textAlign: "right",
                    wordBreak: "break-all",
                  }}
                >
                  {item?.mrp || "0"}
                </div>
              </div>
            </div>
          ))}

          <div className="receipt-bttm-border">
            <div className="receipt-row receipt-totals">
              <div className="receipt-row-1  receipt-total-lbl ">Total</div>
              <div className="receipt-row-2 ">
                {receiptData?.total_gross || "0"}
              </div>
            </div>
            <div className="receipt-row receipt-totals">
              <div className="receipt-row-1  receipt-total-lbl">Discount</div>
              <div className="receipt-row-2">
                {receiptData?.discount || "0"}
              </div>
            </div>
          </div>
          <div className="receipt-bttm-border ">
            <div className="receipt-row receipt-totals">
              <div className="receipt-row-1 receipt-total-lbl">NetAmt</div>
              <div className="receipt-row-2 receipt-black receipt16">
                {receiptData?.total_net || "0"}
              </div>
            </div>
          </div>
          <div className="d-flex flex-row">
            <div className="col-md-8">
              <div>
                <p>(Full Payment Before Investigation)</p>
                Printed By: <span>{receiptData?.printed_by || ""}</span>
              </div>
            </div>
            <div className="col-md-4  d-flex justify-content-end align-items-end">
              <div className="w-75 ">
                <hr
                  style={{ border: "1px solid dashed  black", width: "75%" }}
                />
                <div className="receipt-row ms-3 ps-3">
                  <p>Signature</p>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button className="btn btn-primary" onClick={printReceipt}>
              Download Receipt
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;
